import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { useActivation } from "./ActivationContext";
import s from "./activation.module.css";

/** One-shot celebration when the live quick-start tour finishes. */
export default function QuickStartDoneModal() {
  const {
    allDone,
    tourActive,
    finishTourSession,
    patchCelebrationSeen,
    celebrationSeen,
  } = useActivation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const armed = useRef(false);

  useEffect(() => {
    if (celebrationSeen || open) return;
    if (allDone && (tourActive || armed.current)) {
      setOpen(true);
      armed.current = false;
      return;
    }
    if (tourActive && !allDone) {
      armed.current = true;
    }
  }, [allDone, tourActive, celebrationSeen, open]);

  if (!open) return null;

  const goHome = () => {
    setOpen(false);
    patchCelebrationSeen?.();
    finishTourSession?.();
    navigate("/manage/app");
  };

  return createPortal(
    <div className={s.actDoneBackdrop} role="presentation">
      <div
        className={s.actDoneModal}
        role="dialog"
        aria-modal="true"
        aria-labelledby="act-done-title"
      >
        <div className={s.actDoneBurst} aria-hidden>
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
        <p className={s.actDoneKicker}>Готово</p>
        <h2 id="act-done-title" className={s.actDoneTitle}>
          Клуб готов к работе
        </h2>
        <button type="button" className={s.actDonePrimary} onClick={goHome}>
          На главную
        </button>
      </div>
    </div>,
    document.body,
  );
}
